import { createContext, useContext } from "react";

export const AppGloabalContext = createContext();
export const useGlobalContext = () => useContext(AppGloabalContext);
